
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { instanceOfIWizardObjectReferable } from "../../../../../../../domain/format";
import { IItem } from "../../../../../../../domain/document/items";
import { EditingDocument } from "../../../..";
import { default as ContentMixin } from "./ContentMixin.vue";

@Component
export default class ObjectReferableContentMixin extends Mixins(ContentMixin) {
  get item(): IItem {
    return this.readPropertyOrDefault(s => {
      const content = this.content;
      return instanceOfIWizardObjectReferable(content)
        ? Enumerable.from((s as EditingDocument).itemSets[0].items).firstOrDefault(i => i && (i.id === content.objectIdentifier.id))
        : null;
    }, null);
  }
}
